module.exports = __webpack_public_path__ + "static/media/green-eye-icon.6310bab2.svg";